module.exports = __webpack_public_path__ + "site/img/loc.e595b6f1.png";